import store from '@/store'
import { applyDefaultChildrenIfNoChildren } from '@/components/combined-predict/components/CombinedPredictTable/utils/mappedGroupBuilders'
import { getMainMetadata, buildDescription } from '@/components/combined-predict/models/metadata'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'

const getWebtestMainMetadata = () => {
  const keys = get(modelStateRegistry, 'webtest.keys')
  const mainMetadata = store.getters[`webtest/${keys.getVersion}`] || ''
  const name = mainMetadata?.name
  const compiledAt = mainMetadata?.compiled
  const description = mainMetadata?.description
  const version = mainMetadata?.version
  return getMainMetadata({ name, compiledAt, description, version })
}

const getWebtestDescription = () => {
  const mainMetadata = getWebtestMainMetadata()
  return buildDescription(mainMetadata, { avoidKeys: ['version'] })
}

const getWebtestColumnGroups = () => {
  //   console.log('Fetching Web T.E.S.T. endpoints from store to build column groups...')

  const keys = get(modelStateRegistry, 'webtest.keys')
  const endpoints = store.getters[`webtest/${keys.getEndpoints}`] || []

  if (!Array.isArray(endpoints)) return []
  return endpoints.map((endpoint) =>
    applyDefaultChildrenIfNoChildren({
      id: endpoint.id,
      name: endpoint?.name || endpoint.id,
      unit: endpoint?.units,
      description: endpoint?.description,
      logUnit: endpoint?.logUnits,
      valueDigits: endpoint?.valueDigits,
      logValueDigits: endpoint?.logValueDigits,
    }),
  )
}

export { getWebtestColumnGroups, getWebtestDescription }
